import toast from "components/Toast/dispatch";
import { QuotesReloadProps } from "models/Quote";
import QuoteServices from "services/quote.service";
import ErrorIcon from "img/modalTrash.svg";

const unlockQuote = async (
  item: QuotesReloadProps,
  dispatch: Function,
  refreshItem?: Function,
  getBionexoQuote?: () => {},
  lockOrUnlock?: boolean) => {
  const response = await new QuoteServices().quotationViewed(item.id, lockOrUnlock ?? false);

  if (response) {
    if (refreshItem) {
      refreshItem("viewList.status", lockOrUnlock ?? false, item.id);
    } else if (getBionexoQuote) {
      getBionexoQuote();
    }

    dispatch({ type: 'CLOSE_TOAST' });
    dispatch({ type: 'SET_QUOTE_ITEM', data: { id: "" } });
  }
};

export const toastUnlock = (quote: QuotesReloadProps, dispatch: Function, refreshItem?: Function, getBionexoQuote?: () => {}) =>
  toast.yesNo('Confirmar o desbloqueio da cotação?',
    () => unlockQuote(quote, dispatch, refreshItem, getBionexoQuote, false),
    'Confirmar', 'Cancelar', 100, 14);

export const toastUnlockAfterRA = (quote: QuotesReloadProps, dispatch: Function, refreshItem?: Function, getBionexoQuote?: () => {}) =>
  toast.yesNoCustom('Resposta em andamento',
    'A Resposta Automática ainda não finalizou a atualização. Você pode desbloquear a cotação manualmente, mas certifique-se de verificar a consistência dos dados \n\n Deseja desbloquear?',
    () => unlockQuote(quote, dispatch, refreshItem, getBionexoQuote, false),
    undefined,
    undefined,
    'Confirmar', 
    'Cancelar');

export const toastExclusion = (handleExclusion: Function, quotationId: string, sequenceNumber: number) =>
  toast.yesNoCustom('Deseja excluir o envio desse item?',
    'Caso confirme, o item será enviado para a aba de itens "não preenchidos"',
    () => handleExclusion(quotationId, sequenceNumber),
    ErrorIcon,
    80,
    'Confirmar',
    'Cancelar');

export const toastCanceled = (dashNavigate: Function) =>
  toast.errorCustom("Atualização: cotação cancelada", "A cotação não pode ser enviada. Cancelada pelo cliente.", undefined, undefined, 'Fechar', undefined, undefined, undefined, dashNavigate);